import { useNavigate } from "@tanstack/react-router";
import { Settings2Icon } from "lucide-react";
import { openWorldRoomLocalModels } from "~/neucleos/worldViewController";
import { Button } from "../ui/button";

/** Opens settings without changing the current session's selected model. */
export function ManageModelsButton({ onOpen }: { onOpen?: (() => void) | undefined }) {
  const navigate = useNavigate();
  return (
    <Button
      type="button"
      size="xs"
      variant="ghost"
      onClick={() => {
        onOpen?.();
        if (!openWorldRoomLocalModels()) void navigate({ to: "/settings/local-models" });
      }}
    >
      <Settings2Icon className="size-3.5" /> Local models
    </Button>
  );
}
